const main = () => {
    if (!document.querySelector('#page-entry-participant-confirm')) return false;

    $('form').append('<input id="sendFlg" type="hidden" value="" />');
    $('form').submit(e => {
        if ($('input#sendFlg').val()) {
            $('button[value="send"]').prop('disabled', true)
        }
    });

    $('.step-confirm button[value="send"]').on('click', e => {
        $('input#sendFlg').val("1");
    })
}

export default main;